import { render } from "./UploadFileView.vue?vue&type=template&id=08a7c3e6"
import script from "./UploadFileView.vue?vue&type=script&lang=js"
export * from "./UploadFileView.vue?vue&type=script&lang=js"

import "./UploadFileView.vue?vue&type=style&index=0&id=08a7c3e6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__